import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type TrelloDeleteAttachmentFromCardActionFieldsFragment = (
  { __typename: 'TrelloDeleteAttachmentFromCardAction' }
  & Pick<Types.TrelloDeleteAttachmentFromCardAction, 'id' | 'date' | 'displayKey' | 'type'>
  & { displayEntities?: Types.Maybe<(
    { __typename: 'TrelloDeleteAttachmentFromCardActionDisplayEntities' }
    & { attachment?: Types.Maybe<(
      { __typename: 'TrelloActionAttachmentEntity' }
      & Pick<Types.TrelloActionAttachmentEntity, 'link' | 'type' | 'url'>
    )>, card?: Types.Maybe<(
      { __typename: 'TrelloActionCardEntity' }
      & Pick<Types.TrelloActionCardEntity, 'objectId' | 'shortLink' | 'text' | 'type'>
    )>, memberCreator?: Types.Maybe<(
      { __typename: 'TrelloActionMemberEntity' }
      & Pick<Types.TrelloActionMemberEntity, 'text' | 'type'>
    )> }
  )>, appCreator?: Types.Maybe<(
    { __typename: 'TrelloAppCreator' }
    & Pick<Types.TrelloAppCreator, 'id' | 'name'>
  )>, creator?: Types.Maybe<(
    { __typename: 'TrelloMember' }
    & Pick<Types.TrelloMember, 'id'>
  )> }
);

export const TrelloDeleteAttachmentFromCardActionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'TrelloDeleteAttachmentFromCardActionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloDeleteAttachmentFromCardAction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayEntities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TrelloActionAttachmentEntityFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TrelloActionCardEntityFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'memberCreator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TrelloActionMemberEntityFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TrelloCoreActionFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloActionAttachmentEntityFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloActionAttachmentEntity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'link' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloActionCardEntityFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloActionCardEntity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'objectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloActionMemberEntityFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloActionMemberEntity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloCoreActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloAction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appCreator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseTrelloDeleteAttachmentFromCardActionFieldsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      TrelloDeleteAttachmentFromCardActionFieldsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseTrelloDeleteAttachmentFromCardActionFieldsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<TrelloDeleteAttachmentFromCardActionFieldsFragment>,
    'data'
  > {
  data?: TrelloDeleteAttachmentFromCardActionFieldsFragment;
}

export const useTrelloDeleteAttachmentFromCardActionFieldsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseTrelloDeleteAttachmentFromCardActionFieldsFragmentOptions): UseTrelloDeleteAttachmentFromCardActionFieldsFragmentResult => {
  const result =
    Apollo.useFragment<TrelloDeleteAttachmentFromCardActionFieldsFragment>({
      ...options,
      fragment: TrelloDeleteAttachmentFromCardActionFieldsFragmentDoc,
      fragmentName: 'TrelloDeleteAttachmentFromCardActionFields',
      from: {
        __typename: 'TrelloDeleteAttachmentFromCardAction',
        ...from,
      },
    });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as TrelloDeleteAttachmentFromCardActionFieldsFragment,
  };
};
